import { HStack, VStack } from '@chakra-ui/react';
import React, { useEffect, useMemo } from 'react';
import BlueTopPage from '../BlueTopPage';
import CustomButton from '@/components/atoms/CustomButton';
import { useNavigate } from '@tanstack/react-router';
import colors from '@/theme/colors';
import * as Sentry from '@sentry/react';

type TErrorBoundary = {
  code: number;
  data: any;
  success: boolean;
  errors: {
    message: string;
    code: number;
    name: string;
    payload: any;
  }[];
  cause?: string;
  error?: { message: string };
};

const ErrorBoundaryComponent = ({ error }: { error: unknown }) => {
  const castError = error as TErrorBoundary;
  const navigate = useNavigate();

  const finalError = useMemo(() => {
    if (castError.errors?.[0]?.message) return castError.errors[0].message;
    if (castError.error?.message) return castError.error?.message;
    return castError.cause;
  }, [castError]);

  useEffect(() => {
    Sentry.captureException(finalError ?? 'Error caught by ErrorBoundaryComponent');
  }, [finalError]);

  return (
    <BlueTopPage title="Oh-oh! Something went wrong" description="">
      <VStack gap={'50px'}>
        <HStack>{<pre>Error: {finalError ?? 'An error has occurred. Please reload the page or go back.'}</pre>}</HStack>
        <CustomButton
          backgroundColor={colors.primary[500]}
          hoverBackgroundColor={colors.primary[500]}
          width={'200px'}
          height={'50px'}
          labelColor="white"
          onClick={() => navigate({ to: '/' })}
          label="Home"
        />
      </VStack>
    </BlueTopPage>
  );
};

export default ErrorBoundaryComponent;
